
import React from 'react';
import { AssessmentProgress } from './AssessmentProgress';
import { AssessmentSection, AssessmentStep } from '@/types/assessment-types';

interface AssessmentNavigationProps {
  currentStep: AssessmentStep;
  sections: AssessmentSection[];
  onNavigateSection: (sectionId: string) => void;
}

export const AssessmentNavigation: React.FC<AssessmentNavigationProps> = ({
  currentStep,
  sections,
  onNavigateSection
}) => {
  const isValidSection = (sectionId: string): sectionId is AssessmentStep => {
    const validSteps: AssessmentStep[] = [
      'start',
      'productCraft',
      'customerDiscovery',
      'researchDesign',
      'marketImpact',
      'productOperations',
      'industryImpact',
      'results'
    ];
    return validSteps.includes(sectionId as AssessmentStep);
  };

  return (
    <AssessmentProgress
      currentStep={currentStep}
      sections={sections}
      onNavigateSection={(sectionId) => {
        if (isValidSection(sectionId)) {
          onNavigateSection(sectionId);
        }
      }}
      isAssessmentCompleted={currentStep === 'results'}
    />
  );
};
